module.exports = __webpack_public_path__ + "img/0-9.5459c95f.gif";